"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var VgStates = (function () {
    function VgStates() {
    }
    VgStates.VG_ENDED = 'ended';
    VgStates.VG_PAUSED = 'paused';
    VgStates.VG_PLAYING = 'playing';
    VgStates.VG_LOADING = 'waiting';
    VgStates.decorators = [
        { type: core_1.Injectable },
    ];
    return VgStates;
}());
exports.VgStates = VgStates;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmctc3RhdGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvcmUvc3RhdGVzL3ZnLXN0YXRlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLHNDQUF5Qzs7Ozt3QkFJWCxPQUFPO3lCQUNOLFFBQVE7MEJBQ1AsU0FBUzswQkFDVCxTQUFTOztnQkFMeEMsaUJBQVU7O21CQUZYOztBQUdhLDRCQUFRIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHtJbmplY3RhYmxlfSBmcm9tICdAYW5ndWxhci9jb3JlJztcblxuQEluamVjdGFibGUoKVxuZXhwb3J0IGNsYXNzIFZnU3RhdGVzIHtcbiAgICBzdGF0aWMgVkdfRU5ERUQ6IHN0cmluZyA9ICdlbmRlZCc7XG4gICAgc3RhdGljIFZHX1BBVVNFRDogc3RyaW5nID0gJ3BhdXNlZCc7XG4gICAgc3RhdGljIFZHX1BMQVlJTkc6IHN0cmluZyA9ICdwbGF5aW5nJztcbiAgICBzdGF0aWMgVkdfTE9BRElORzogc3RyaW5nID0gJ3dhaXRpbmcnO1xufVxuIl19


//////////////////
// WEBPACK FOOTER
// ./node_modules/videogular2/src/core/states/vg-states.js
// module id = 45
// module chunks = 1